import { render, staticRenderFns } from "./EmbedContent.vue?vue&type=template&id=d8004456&"
import script from "./EmbedContent.vue?vue&type=script&lang=js&"
export * from "./EmbedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports